import { render, staticRenderFns } from "./ProjectYearlyCompareTable.vue?vue&type=template&id=4b578f88&"
import script from "./ProjectYearlyCompareTable.vue?vue&type=script&lang=js&"
export * from "./ProjectYearlyCompareTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports